// Local stand-in for a missing/loading album cover: a plain gray tile with the album's first letter
// (blank until the name is known). Never shows image dimensions.
const cache = {};

export const coverPlaceholder = (name) => {
  const letter = (name || '').trim().charAt(0).toUpperCase();
  if (cache[letter]) return cache[letter];
  const glyph = letter
    ? `<text x="50" y="50" dy=".35em" text-anchor="middle" font-family="-apple-system,Helvetica,Arial,sans-serif" font-size="44" font-weight="600" fill="#ffffff" fill-opacity=".85">${
        letter.replace(/[&<>"]/g, c => `&#${c.charCodeAt(0)};`)}</text>`
    : '';
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#6b7280"/>${glyph}</svg>`;
  return (cache[letter] = `data:image/svg+xml,${encodeURIComponent(svg)}`);
};
